import {css} from 'lit';

import {defaultStyles} from '../../../components/textarea.js';

export const styles = defaultStyles.extends({
  statics: css``,
  colorGen: () => '',
  sizeGen: () => '',
});

export default {styles};
